import * as React from 'react'

import { Box, tokens } from '@factorialco/deprecated-design-system'

import SummaryCard from './_SummaryCard'

const Summary = () => {
  return (
    <Box gap="s24" alignItems="flexEnd" position="sticky" style={{ top: tokens.dimensions.s16 }}>
      <SummaryCard />
    </Box>
  )
}

export default Summary
